import React, { useState } from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import "./datePickerHL.css";

/**
 * @param {*} props
 * @return {*}
 * @status no delete 
 * @description Component that helps user set dates in DD/MM/YYYY format
 */
const DataPickerHLPure = (props) => {
  const {
    labelDataPicker, //Label dataPicker
    valueDate, //Date select
    maxDate, //Max date
    limitDate, //Limit date
    handleChangeDate, //Function to change date
    handleBlurDate, //Function to handle on blur
    tooltipShow, //True or false to show tooltip
    titleTooltip, //Title tooltip string
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description
    restContent, //More text to tooltip description
    informationIcon, // Choose the information icon true or false to custom img
    disabled = false, //True to disable input
    stylePicker
  } = props;

  //Example to use
  // const [valueDate, setValueDate] = useState(dateFrom || null);

  // const handleChange = (event) => {
  //   setValueDate(event.value);
  // };

  return (
    <div className="dataPickerHLPure-container" style={stylePicker}>
      <div className="dataPickerHLPure-container-text">
        {labelDataPicker && <label className="eticket-form-label">{labelDataPicker}</label>}
        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
      </div>
      <DatePicker
        id={"date"}
        name={"date"}
        min={limitDate}
        max={maxDate}
        value={valueDate}
        format="dd/MM/yyyy"
        // defaultValue={valueDate}
        onChange={handleChangeDate}
        onBlur={handleBlurDate}
        className="dataPickerHLPure-style"
        disabled={disabled}
        rounded={null}
        placeholder={''}
      />
    </div>
  );
};

export { DataPickerHLPure as default };

